document.addEventListener('click', (event) => {
 const menu = event.target.closest('[data-reluma-menu-toggle]');
 if (menu) {
  const panel = document.getElementById(menu.getAttribute('aria-controls'));
  if (panel) { const open = menu.getAttribute('aria-expanded') !== 'true'; menu.setAttribute('aria-expanded', String(open)); panel.hidden = !open; }
 }
 const zoom = event.target.closest('[data-reluma-zoom]');
 if (zoom) { const dialog = document.getElementById(zoom.dataset.relumaZoom); if (dialog) dialog.showModal(); }
 const close = event.target.closest('[data-reluma-close]');
 if (close) close.closest('dialog').close();
 if (event.target.matches('.reluma-zoom-dialog')) event.target.close();
});
